import React, { useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { extractDateFromStr, getLatestUpdatedObject } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import PdfZipItem from "../../components/PdfZipItem";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const GuideLineForReleasePage = () => {
  const { getText } = useLanguageTranslation();
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: guidelineData = [], isLoading: guidelineIsLoading } =
    useGetProtectedApiDataQuery({
      url: "guidelines_for_release_arbitral_awards",
      lang: languageType,
    });
  useTableResponsive(guidelineData);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(guidelineData)?.changed);
  }, [guidelineData]);

  if (guidelineIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
        titleLink="/guideline-for-release"
        levelTwo={false}
        levelThree={false}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("Download", "डाउनलोड")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {guidelineData.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Description", "विवरण")}>
                            {item.title}
                          </td>
                          <td data-key={getText("Download", "डाउनलोड")}>
                            <PdfZipItem
                              filePath={item?.field_download}
                              filesize={item?.filesize}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuideLineForReleasePage;
